import React, { useCallback } from 'react';
import SelectField from 'forms/fields/SelectField/index.js';
export const DevicesSelectField = ({options, value, onChange: onMediaChange}) => {
    if (options.length === 0) { return null; }
    const onChange = useCallback((e) => {
        onMediaChange(e?.target?.value);
    }, [onMediaChange]);
    return (
        <SelectField
            value={value}
            options={options}
            onChange={onChange}
        />
    )
}
